<template>
  <b-container id="BarDashboard">
    <b-row class="showInfomation" v-if="verification">
      <b-col class="title">
        <div class="message_title">
          <b-row>
            <b-col cols="1">
              <img class="img_title" :src="icon" />
            </b-col>
            <b-col>
              <p>{{ title }}</p>
              <p class="subtitle">{{ subtitle }}</p>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col class="message">
        <p>{{ feedback }}</p>
        <b>{{ percentage || 0 }}%</b>
      </b-col>
      <b-col cols="12" class="d-flex justify-content-end" v-if="showChartOptions">
        <b-form-select id="chart-options" v-model="selected" :options="options" @change="setChartOption"></b-form-select>
      </b-col>
      <v-chart :options="labels" />
    </b-row>
    <b-row class="noInfomation" v-if="!verification">
      <b-col>
        <div class="iconContainer">
          <img :src="iconBig" />
        </div>
        <b>{{ title }}</b>
        <p class="subtitle">{{ subtitle }}</p>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/bar";

export default {
  name: "BarDashboard",
  props: [
    "title",
    "subtitle",
    "feedback",
    "percentage",
    "icon",
    "iconBig",
    "presentations",
    "verification",
    "feedback",
    "percentage",
    "icon",
    "iconBig",
    "labels",
    "showChartOptions",
  ],
  data: () => ({
    info: {},
    selected: 'average',
    options: [
      { value: 'average', text: 'Surveys Average Score' },
      { value: 'number', text: 'Number of Responses' },
    ]
  }),
  methods: {
    setChartOption(option){
      this.$emit('changeChartOption', this.title, option);
    }
  },
  components: {
    "v-chart": ECharts,
  },
};
</script>
<style lang="less">
@import "../../assets/components/common/BarDashboard.less";
</style>